import React, { useState } from 'react';

import Modal from '@mui/material/Modal';
import CloseIcon from '@src/componentsNew/Icons/Icons/CloseIcon';

import "./mobile-review-sorting-filter-style.scss";

import Chip from '@src/componentsNew/Chip';
import Button from '@src/componentsNew/Buttons/Button';
import Typography from '@src/componentsNew/Typography/Typography';

import { ReviewSortField, OrderDirection } from "__generated__/globalTypes";
import { reviewsVariables } from "@molecules/ReviewList/__generated__/reviews";

import { REVIEWS_SORTING_FILTER_OPTIONS } from '@src/utils/constants';

interface IProps {
  open: boolean;
  onClose?: any;
  variables: reviewsVariables;
  setVariables: any;
}

const MobileReviewSortingFilter = ({ open, onClose, variables, setVariables }: IProps) => {
  const [selectedOption, setSelectedOption] = useState(REVIEWS_SORTING_FILTER_OPTIONS.find(option =>
    option.value.field === variables.sortBy.field &&
    option.value.direction === variables.sortBy.direction
  ));

  const handleClickReset = () => {
    // Only Sorting Clear
    setVariables(prev => ({
      ...prev,
      sortBy: {
        field: ReviewSortField.CREATE_AT,
        direction: OrderDirection.DESC,
      }
    }));

    onClose();
  };

  const handleClickShowResult = () => {
    const newOption = REVIEWS_SORTING_FILTER_OPTIONS.find(option =>
      option.value.field === selectedOption.value.field && option.value.direction === selectedOption.value.direction
    );

    setVariables(prev => ({
      ...prev,
      sortBy: newOption.value
    }));

    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="mobile-review-sorting-filter-content">
        <CloseIcon cName="close-btn" onClick={onClose} />

        <div className="sorting-option-area">
          <Chip
            className="sorting-option"
            name={
              <>
                <Typography
                  variant="body3"
                  component="span"
                  style={{ color: "FF3399" }}>
                  {`Sort | `}
                </Typography>
                <Typography
                  variant="subtitle2"
                  component="span"
                  style={{ color: "FF3399" }}>
                  {selectedOption.label}
                </Typography>
              </>
            }
          />
        </div>

        <div className="sorting-option-item-wrapper">
          {
            REVIEWS_SORTING_FILTER_OPTIONS.map((option, idx) =>
              <Typography key={idx}
                cName="sort-option-item"
                variant="body3"
                component="span"
                onClick={() => setSelectedOption(option)}
                style={{ color: "#212121" }}>
                {option.label}
              </Typography>
            )
          }
        </div>

        <div className="action-btn-wrapper">
          <Button cName="reset-btn" variant="contained"
            onClick={handleClickReset}
          >
            Reset
          </Button>
          <Button cName="action-btn" variant="contained"
            onClick={handleClickShowResult}
          >
            Show Result
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default MobileReviewSortingFilter;
